import React from 'react'
import Expires from './SubComponents/Expires'
import Pipes from './SubComponents/Pipes'
import ErrorLogs from './SubComponents/ErrorLogs'
import SetupStatus from './SubComponents/SetupStatus'
import ConnectorImage from './SubComponents/ConnectorImage'

const ConnectorListing = (props) => {
    const displayName = props.name.replace(/^i95Dev\s*/, '')

    return (
        <div className={`nav-link mb-2 connectortab ${props.selectedIndex === props.connectorIndex ? "active" : ""}`}>
            <button
                type="button"
                className="selectionProcessnew"
                title={props.name}
                onClick={() => props.onSelect(props.connectorIndex)}
            ></button>
            <div className="connector-card-body">
                <div className="connector-card-header">
                    <ConnectorImage sourceShortName={props.sourceShortName} targetShortName={props.targetShortName} />
                    <span className="connector-card-title text-truncate" title={displayName}>{displayName}</span>
                    {props.isSetupCompleted ? null : <SetupStatus connectorIndex={props.connectorIndex} />}
                </div>
                <div className="connector-card-divider"></div>
                <div className="connector-meta-row">
                    <Expires expiryDate={props.expiryDate} showActiveBadge={props.showActiveBadge} />
                    <ErrorLogs errorCount={props.errorCount} />
                    <Pipes entityCount={props.entityCount}/>
                </div>
                {props.onViewDetail ?
                    <div className="connector-card-footer">
                        <button
                            type="button"
                            className="btn btn-primary btn-rounded waves-effect waves-light connector-view-detail-btn"
                            title="View Detail"
                            aria-label="View Detail"
                            onClick={(e) => { e.stopPropagation(); props.onViewDetail(props.connectorIndex) }}
                        >
                            <i className="uil-angle-right" aria-hidden="true" />
                        </button>
                    </div>
                    : null
                }
            </div>
        </div>
    )
}

export default ConnectorListing